const PAYMENTS = {
  CASH: "cash",
  STRIPE: "stripe",
  PAYPAL: "paypal"
}

export { PAYMENTS }
